<template>
    <div>
        <div class="row justify-content-center">
           <div class="col-md-7" 
           :style="`background-image:url('${$store.state.data.undangan.gambar4}')`"
          style="background:#100001;position:relative;
          background-size:cover;background-repeat:no-repeat;background-position: center center;min-height:100vh;">
            <!-- <img src="@/static/draw1.jpeg" style="height:130vh;width:100%;position:absolute;right:0;top:0;z-index:10;" alt=""> -->
            <div  v-if="particle" style="height:100%;width:100%;position:absolute;z-index:10000;" id="particlesjs" ></div>
            <br>
            <br><br>
            <br><br>
            <br>
            <div style="" 
              class="d-flex justify-content-center align-items-center shadow-lg rounded-lg">
                  <div style="width:100%" class=" ">
                      <div class="row justify-content-center">
                        <div class="col-10">
                            <p class=" text-center text-3xl wow"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                             style="font-family: 'Glory', sans-serif;letter-spacing: 3px;">
                                THE WEEDING OF
                            </p>
                        </div>
                      </div>
                    <!-- IMAGE -->
                      <img :src="$store.state.data.undangan.gambar1" style="width:55%;height:55%;display:block;margin:auto;"
                       class="rounded-circle shadow wow"
                       :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                        alt="">
                    <!-- IMAGE -->
                      <div class="row justify-content-center">
                        <div class="col-9">
                            <p class=" text-3xl sm:text-5xl  text-center wow"
                            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                             style="letter-spacing: 4px;word-spacing: 4px;font-family: 'Alex Brush', cursive;">
                                {{$store.state.data.undangan.nama_singkat1}} & {{$store.state.data.undangan.nama_singkat2}}
                            </p>
                            <p class=" text-center mb-2 wow"
                            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                             style="font-family: 'Urbanist', sans-serif;font-size:16px;" v-html="$store.state.data.undangan.text_tanggal">
                            </p>
                            <div class="grid-item2" style="font-family: 'Urbanist', sans-serif;">
                                <div class="shadow rounded-lg p-2 bg-orange-600 border-2 border-yellow-300 font-semibold text-center wow"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                                >
                                    {{tanggal.split(',')[0]}} <br>
                                    Days
                                </div>
                                <div class="shadow rounded-lg p-2 bg-orange-600 border-2 border-yellow-300 font-semibold text-center wow"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                                >
                                    {{tanggal.split(',')[1]}} <br>
                                    Hours
                                </div>
                                <div class="shadow rounded-lg p-2 bg-orange-600 border-2 border-yellow-300 font-semibold text-center wow"
                                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                                >
                                    {{tanggal.split(',')[2]}} <br>
                                    Minutes
                                </div>
                                <!-- <div class="shadow rounded-lg p-2 bg-blue-300 text-center">
                                    0 <br>
                                    Seconds
                                </div> -->
                            </div>
                            <p class="text-center font-semibold p-3 mb-4 wow"
                            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                             style="font-family: 'Urbanist', sans-serif;">
                                <br>
                                {{format($store.state.data.acara[0].tanggal_acara)}}
                            </p>
                        </div>
                      </div>
                  </div>
              </div>
              <br>
            <br><br>
            <br>
          </div>
        </div>
    </div>
</template>
<script>
import 'particles.js'
import autophp from '@/plugins/autophp';
 var id = require("date-fns/locale/id");
let sdb = new autophp();
let urlnya="https://undangan.officialapp.website";
export default{
    data(){
        return{
            undangan:[],
            tanggal:''
        }
    },
  props:['particle'],
    mounted() {
        window.particlesJS("particlesjs", this.$store.state.particle)
        this.tanggal = this.timeDiffCalc(new Date(this.$store.state.data.acara[0].tanggal_acara),new Date());
    },
    methods: {
        getUndangan(){
            sdb.collection("app_undangan_nikah",false,urlnya).doc().select(`select *,tb1.id as id from app_undangan_nikah tb1 left join app_undangan_nikah_mempelai tb2 on tb2.id=tb1.mempelai where tb1.id='${this.$route.query.id}'`).then(res => {
                this.undangan=res[0];
                console.log(this.undangan)
                this.tanggal = this.timeDiffCalc(new Date(res[0].tanggal_akad),new Date());
                this.$forceUpdate();
            });
        },
         format(tgl) {
            return this.$datefns.format(
                new Date(tgl),
                "dddd, DD MMMM YYYY",
                 {
                  locale: id,
                }
            )
        },
         timeDiffCalc(dateFuture, dateNow) {
            let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

            // calculate days
            const days = Math.floor(diffInMilliSeconds / 86400);
            diffInMilliSeconds -= days * 86400;

            // calculate hours
            const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
            diffInMilliSeconds -= hours * 3600;

            // calculate minutes
            const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
            diffInMilliSeconds -= minutes * 60;

            let difference = '';
            if (days > 0) {
            difference += (days === 1) ? `${days}, ` : `${days}, `;
            }

            difference += (hours === 0 || hours === 1) ? `${hours}, ` : `${hours}, `;

            difference += (minutes === 0 || hours === 1) ? `${minutes}` : `${minutes}`; 

            return difference;
        },
    },
}
</script>
<style>
.grid-item2 {
    display: grid;
    /* repeat(jumlah column, 1fr) */
    grid-template-columns: repeat(3, 1fr);
    /* repeat(jumlah row) */
    grid-template-rows: repeat(1, 1fr); 
    grid-column-gap: 10px;
    grid-row-gap: 10px;
}
</style>